
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {
    Container,
    Typography,
    useMediaQuery,
    useTheme,
    Box,
    IconButton,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {  GetApp,  Backup, LockOpen, History,  BeenhereOutlined, SendOutlined, ListAltOutlined, ArrowBack} from '@mui/icons-material';
import { formatDate, history,  useSelectedAssignmentInfo, useInternetStatusDetector, getAppsBuildings, setLocalStorageItem, getLocalStorageItem, SurveyType, isCompleteAssignment } from '../../_helpers';
import { green, red } from '@mui/material/colors';
import { AssignmentCustomRow } from './components/AssignmentCustomRow';
import { surveyActions, syncsActions } from '../../_actions';
import SyncInfoModal from "./components/SyncInfoModal";
import ReleaseLockConfirmModal from "./components/ReleaseLockConfirmModal";
import SelectResponsiblePerson from "./components/SelectResponsiblePerson";
import SelectSingleObjectModal from "../../components/SelectSingleObjectModal";
import LinkAssignmentModal from "./components/LinkAssignmentModal";
import { generatePath } from 'react-router-dom';
import { flushSync } from "react-dom";
import { apps, LOCAL_STORAGE_GRID_KEYS } from '../../_constants';
import { INITIAL_ROW_SELECTION_MODEL } from '../../components/DataGridV2/constants';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import DataGridV2 from '../../components/DataGridV2';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getAssignmentColumns } from './assignmentUtils';
import { getIdsForGridSelectedRows } from '../../_helpers/getIdsForGridSelectedRows';


export default function AssignmentsGrid({ ...props }) {
    const classes = useStyles();
    const { t , i18n} = useTranslation();
    const apiRef = useGridApiRef();
    const theme = useTheme()
    const location = useLocation()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const dispatch = useDispatch();
    const [canGoBack, setCanGoBack] = useState(false);
    const [isObjectModal, setIsObjectModal] = useState(false);
    const [mappedState, setMappedState] = useState({ selectedBuildingId: null, selectedObjectId: null });
    const [linkAssignment, setLinkAssignment] = useState({ element: null, data: null });
    const openLinkModal = Boolean(linkAssignment.element);
    const OpenLinkModalId = openLinkModal ? 'simple-popover' : undefined;
    const [openSyncInfoModal, setOpenSyncInfoModal] = useState(false);
    const [organizationLoading, setOrganizationLoading] = useState(false)
    const [canChangeResponsiblePerson, setCanChangeResponsiblePerson] = React.useState(null);
    const [openReleaseLockConfirmModal, setOpenReleaseLockConfirmModal] = useState(false);
    const [all, setAll] = useState([]);
    const isOnline = useInternetStatusDetector();
    const app = useSelector((state) => state.app);    
    const keyPrefix = app === apps.aftercare ? "AFTERCARE" : app === apps.huisinfo ? "BUYERS_GUIDE" : app === apps.constructionQuality ? "CONSTRUCTION_QUALITY" : "GENERAL";
    const [filterModel,setFilterModel] = useState( () => getLocalStorageItem(LOCAL_STORAGE_GRID_KEYS.ASSIGNMENTS_COLUMN_FILTER[keyPrefix], undefined))

    const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
        LOCAL_STORAGE_GRID_KEYS.ASSIGNMENTS_PAGINATION[keyPrefix], undefined
    ))
    const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL); 

 

    //Redux State
    const { user } = useSelector(state => state.authentication);
    const { selected } = useSelector(state => state.buildings);
    const { selectedAssignment, wbProjectInfo, assignmentLockIds = [], assignments, isInternalCompleteAssignmentLoading, resetAssignmentLoading, isCompleteAssignmentLoading, loadingAssignments } = useSelector(state => state.surveying);

      const assignmentsIds =  useMemo(() => {
         return getIdsForGridSelectedRows(rowSelectionModel,assignments)
        },[rowSelectionModel, assignments]);

    const formattedRowsSelected = useMemo(() => {
        if (!assignmentsIds?.length) {
            return { list: [], data: [] };
        }
        return {
            list: assignmentsIds,
            data: assignmentsIds.map((id) => ({ assignmentId: id })),
        };
    }, [assignmentsIds]); 
 
    const {
        canSyncUp: canSyncUpAssignments, canSyncDown: canSyncDownAssignments,canRelease : canReleaseAssignments,
        canResetStatus: canResetAssignmentsStatus, canSendToWB: canSendToWBAction, isAnyCompletedAssignment: isCompletedAssignment,
        isNotAnyInternalComplete: isNotAnyInternalCompleted, isAllAnswerSelected: canAnswerIsSelected, isAnyLocked: canLockedAssignments
    } = useSelectedAssignmentInfo(formattedRowsSelected);
    

    const wbStatusOptions = [
        ...new Set(assignments.map((item) => item.wbStatus))
    ];

   
    useEffect(() => {
        if (selected) {
            getAppsBuildings({ projectId: selected.projectId || "" }).then(async res => {
                setAll(res)
            }).catch((er) => {
                console.log(er)
            })
        }
    }, [selected]);

    useEffect(() => {
        if (selected && selected.projectId)
            dispatch(surveyActions.getAssignmentsList(selected.projectId))
        dispatch(surveyActions.getWBProjectInoAction(selected.projectId));
    }, [selected, history.location, isOnline]);

     useEffect(() => {
            if (selectedAssignment) dispatch(surveyActions.clearAssignmentDetails());
        }, []);

    const rows = assignments.map((assignment) => {
        const { surveyingMomentDetails, hasUpdate, isCracked, lockId } = assignment;

        const lockInfo = assignmentLockIds?.find(a => a.lockId === lockId);

        let downloadStatus = "notdownload";
        if (lockInfo && lockInfo.userId === user.id && lockId) {
            downloadStatus = "download";
        } else if (!lockInfo && lockId) {
            downloadStatus = "locked";
        }

        return {
            ...assignment,
            id: assignment.assignmentId,
            hasPriority: hasUpdate,
            hasError: surveyingMomentDetails.objectId && !surveyingMomentDetails.isBuildingMapped,
            hasDownload: downloadStatus,
            isCracked: isCracked,
            repairRequests:assignment?.repairRequests ? assignment?.repairRequests?.length : 0,
            relationName:assignment?.assignedPerson?.relationName,
            responsiblePersonRelationName : assignment?.responsiblePerson?.relationName
        };
    });

    const downloadStatuses = [...new Set(rows.map(r => r.hasDownload))];

    const extraInformationOptions = downloadStatuses.map(status => ({
        value: status,
        label:
            status === "download"
                ? t("survey.filter.download")
                : status === "locked"
                    ? t("survey.filter.locked")
                    : t("survey.filter.notDownloaded"),
    }));

  
    useEffect(() => {
        const locationState = location?.state;
        const newFilterModelItems = locationState?.filters ?? [];
        setFilterModel(
            newFilterModelItems?.length > 0
                ? {
                    items: newFilterModelItems,
                    logicOperator: "and",
                    quickFilterValues: [],
                    quickFilterLogicOperator: "and",
                }
                : filterModel ?? {
                    items: [],
                    logicOperator: "and",
                    quickFilterValues: [],
                    quickFilterLogicOperator: "and",
                }
        );
       if (locationState && locationState?.canGoBack) setCanGoBack(true);

    }, [location?.state]);
     
    const handleInternalCompleteAssignment = (payload) => {        
        dispatch(surveyActions.completeInternalAssignments(payload.map(a => a.assignmentId)));
    }

    const handleResetAssignmentStatus = (assignmentIds) => {
        dispatch(surveyActions.resetAssignmentStatusAction(assignmentIds.map(a => a.assignmentId)));
    }

    const handleCompleteAssignment = (payload) => {
        dispatch(surveyActions.assignmentsComplete(payload.map(a => a.assignmentId)));
    }

    const handleInfoSyncClose = () => {
        setOpenSyncInfoModal(false);
        setRowSelectionModel(INITIAL_ROW_SELECTION_MODEL)
    }

    const openReleaseLockConfirmationModal = () => {
        setOpenReleaseLockConfirmModal(true);
    }

    const assignmentsSyncDownHandler = () => {
        setOpenSyncInfoModal(true);
        const assignmentsFlatData = assignments.map(a => ({
            ...a,
            surveyMomentId: a.surveyingMomentDetails.surveyingMomentId,
            objectId: a.surveyingMomentDetails.objectId,
            lockId: `${new Date().getTime()}-${a.assignmentId}`,
            controlPointDesc: a.text
        }));
        const selected = formattedRowsSelected.data.map(({ assignmentId }) => assignmentsFlatData.find(a => a.assignmentId === assignmentId));
        dispatch(syncsActions.assignmentSyncDown(selected));
    }

    const assignmentsSyncUpHandler = () => {
        setOpenSyncInfoModal(true);
        const assignmentsFlatData = assignments.map(a => ({
            ...a,
            surveyMomentId: a.surveyingMomentDetails.surveyingMomentId,
            objectId: a.surveyingMomentDetails.objectId,
            controlPointDesc: a.text
        }));
        const selected = formattedRowsSelected.data.map(({ assignmentId }) => assignmentsFlatData.find(a => a.assignmentId === assignmentId));
        dispatch(syncsActions.assignmentSyncUp(selected));
    };

    const releaseLockHandler = () => {
        setOpenSyncInfoModal(true);
        setOpenReleaseLockConfirmModal(false)
        const assignmentsFlatData = assignments.map(a => ({
            ...a,
            surveyMomentId: a.surveyingMomentDetails.surveyingMomentId,
            objectId: a.surveyingMomentDetails.objectId,
            controlPointDesc: a.text
        }));
        const selected = formattedRowsSelected.data.map(({ assignmentId }) => assignmentsFlatData.find(a => a.assignmentId === assignmentId));
        const canClean = selected.some(p => {
            const lockInfo = assignmentLockIds && assignmentLockIds.find(a => a.lockId === p.lockId);
            return lockInfo && lockInfo.userId === user.id;
        });
        dispatch(syncsActions.releaseLock(selected, canClean, "Opdracht"));
    }

    const isOpenResponsibleDrawer = (e, name) => {
        setCanChangeResponsiblePerson(e.currentTarget)
    }

    const handleChangeResponsiblePersonForAssignment = async ({ orgId, ...data }) => {
        data = {
            loginId: data.loginId,
            workorderRight: data.workOrderRight,
            repairRequestRight: data.repairRequestRight,
            ids: formattedRowsSelected.data.map(p => p.assignmentId),
        }
        await dispatch(surveyActions.updateAssignedPersonForAssignment(data, formattedRowsSelected.data.map(p => p.assignmentId), true, orgId));
        await dispatch(surveyActions.getAssignmentsList(selected.projectId));
    };


    const followUpAssignmentsHandler = (event, data, type) => {        
        event.stopPropagation()
        setLinkAssignment({ element: event.currentTarget, data, type })
    }

    const followUpAssignmentsHandlerClose = (event) => {
        setLinkAssignment({ element: null })
    };

    const objectModalListHandler = (event, selectedBuildingId, selectedObjectId) => {
        event.stopPropagation();
        setIsObjectModal(true);
        setMappedState({ selectedBuildingId, selectedObjectId });
    }

    const handleCloseObjects = () => {
        setIsObjectModal(false);
        setMappedState({ selectedBuildingId: null, selectedObjectId: null });
    };

    const handleSaveObjects = (buildingId) => {
        dispatch(surveyActions.mapBuildingObject({ objectId: mappedState.selectedObjectId, buildingId }))
        handleCloseObjects();
    }

    const getGeneratedPath = (params = {}) => {
        if (props.match.params.projectNo)
            return generatePath(props.match.path, { ...props.match.params, ...params })
        return `${props.match.url}/${params.projectNo}`;
    }

    const handleRowClick = selectedRow => {
        const { objectId, surveyingMomentId } = selectedRow.surveyingMomentDetails;
        history.push(`${getGeneratedPath({ assignmentId: selectedRow.assignmentId })}/opdracht/${selectedRow.assignmentId}${objectId ? `?toezichtmomentId=${surveyingMomentId}&objectId=${objectId}` : ''}`, { canGoBack, assignmentId: selectedRow.assignmentId, });
    }

    const isReadOnlyAssignment = () => {
        const selectedAssignments = formattedRowsSelected?.data?.map((row) => {
          return assignments?.find((assignment) => assignment?.assignmentId === row?.assignmentId);
        });
        let isReadOnly = false
        const firstSurveyingMomentId = selectedAssignments?.[0]?.surveyingMomentId;
        const firstObjectId = selectedAssignments?.[0]?.objectId;
        
        const isAllAssignmentsFromSameSurveyingMoment = selectedAssignments?.every((assignment) => assignment?.surveyingMomentId === firstSurveyingMomentId);
        const isAllAssignmentsForSameObject = selectedAssignments?.every((assignment) => assignment?.objectId === firstObjectId);
        
        if (selectedAssignments && selectedAssignments?.length > 0) {
            selectedAssignments?.forEach((assignment) => {
              const lockInfo =
                assignmentLockIds &&
                assignmentLockIds.find((a) => a?.lockId === assignment?.lockId);
              if (
                !assignment?.surveyingMomentDetails?.isBuildingMapped ||
                !wbProjectInfo ||
                (wbProjectInfo && wbProjectInfo?.archivedAt) ||
                isCompleteAssignment(assignment?.internalStatus) ||
                (!lockInfo && assignment?.lockId) || !isAllAssignmentsFromSameSurveyingMoment ||
                !isAllAssignmentsForSameObject
              ) {
                isReadOnly = true  
              } 
            });
          }
          return isReadOnly
      };

    const getAssignmentsForPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
        const userSelectedRows = isAllSelected
            ? rows
            : idsToExport.map((id) => rows.find((item) => item.assignmentId === id));

        const results = userSelectedRows?.map((row) => {
            return columns.reduce((obj, col) => {
                const field = col.field;
                const value = row[field];

                switch (field) {
                    case "hasPriority": {
                        obj[field] = value
                            ? [{ icon: "PriorityHigh", color: "secondary" }]
                            : [];
                        break;
                    }

                    case "hasError": {
                        obj[field] = value
                            ? [{ icon: "ErrorOutline", color: "error" }]
                            : [];
                        break;
                    }

                    case "hasDownload": {
                        switch (value?.toLowerCase?.()) {
                            case "download":
                                obj[field] = [{ icon: "GetApp", color: "primary" }];
                                break;
                            case "locked":
                                obj[field] = [{ icon: "Lock", color: "primary" }];
                                break;
                            default:
                                obj[field] = [];
                        }
                        break;
                    }

                    case "isCracked": {
                        obj[field] = value
                            ? [{ icon: "Warning", color: "primary" }]
                            : [];
                        break;
                    }

                    case "answer": {
                        let answer = {};
                        if (row.answer && row.answerOptions) {
                            answer =
                                row.answerOptions.find(
                                    (ans) => ans.answerOption === row.answer
                                ) || {};
                        }
                        obj[field] = answer.answerOptionLabel || "";
                        break;
                    }

                    case "startDate": {
                        obj[field] = row.startDate
                            ? formatDate(new Date(row.startDate), false, "-")
                            : "";
                        break;
                    }

                    case "endDate": {
                        obj[field] = row.endDate
                            ? formatDate(new Date(row.endDate), false, "-")
                            : "";
                        break;
                    }

                    case "repairRequests": {
                        obj[field] = value ? value.length : 0;
                        break;
                    }

                    case "responsiblePerson": {
                        obj[field] = value ? value.relationName : "";
                        break;
                    }

                    case "assignedPerson": {
                        obj[field] = value ? value.relationName : "";
                        break;
                    }

                    case "internalStatus": {
                        obj[field] = t("wkb.assignment.internalStatus." + value);
                        break;
                    }

                    case "wbReceivedDate": {
                        obj[field] = value ? formatDate(new Date(value)) : "";
                        break;
                    }

                    case "wbJudgmentDate": {
                        obj[field] = value ? formatDate(new Date(value)) : "";
                        break;
                    }

                    default: {
                        if (col.type === "date" && value) {
                            obj[field] = formatDate(new Date(value), false, "-");
                        } else {
                            obj[field] = value ?? "";
                        }
                        break;
                    }
                }

                return obj;
            }, {});
        });

        return results;
    };



    const columns = getAssignmentColumns({ t, keyPrefix, i18n, apiRef, theme, classes, objectModalListHandler, user, wbProjectInfo, assignmentLockIds, followUpAssignmentsHandler, wbStatusOptions, extraInformationOptions })
 
    const getToolbarProps = useMemo(() => {
        const hasSelection = assignmentsIds?.length > 0;

        return {
            title: t("drawing.dossier.library.title"),
            taskMenuListItems: hasSelection
                ? [
                    {
                        title: t("wkb.provisionallyCompleted"),
                        icon: SendOutlined,
                        isLoading: isInternalCompleteAssignmentLoading,
                        disabled:
                            isInternalCompleteAssignmentLoading ||
                            !assignmentsIds.length ||
                            !canAnswerIsSelected ||
                            !isNotAnyInternalCompleted ||
                            canLockedAssignments,
                        onClick: () => handleInternalCompleteAssignment(formattedRowsSelected.data),
                    },
                    ...(canResetAssignmentsStatus && !canLockedAssignments ? [
                        {
                            title: t("wkb.resetAssignmentStatus"),
                            icon: BeenhereOutlined,
                            disabled: !canResetAssignmentsStatus || resetAssignmentLoading || canLockedAssignments,
                            onClick: () => handleResetAssignmentStatus(formattedRowsSelected.data),
                            isLoading: resetAssignmentLoading,
                        }
                    ] : []),
                    {
                        title: t("wkb.sendToWB"),
                        icon: BeenhereOutlined,
                        isLoading: isCompleteAssignmentLoading,
                        disabled:
                            !isOnline ||
                            isCompleteAssignmentLoading ||
                            !canSendToWBAction ||
                            !assignmentsIds.length ||
                            !canAnswerIsSelected ||
                            canLockedAssignments,
                        onClick: () => handleCompleteAssignment(formattedRowsSelected.data),
                    },
                    {
                        title: t("wkb.assignment.changeDelegator"),
                        icon: ListAltOutlined,
                        isLoading: organizationLoading,
                        disabled: !assignmentsIds.length || organizationLoading || !isOnline || isReadOnlyAssignment(),
                        onClick: (e) =>
                            isOpenResponsibleDrawer(e, "VeranderVerantwoordelijkeOpdracht"),
                    },
                    ...(!canSyncUpAssignments ? [
                        {
                            title: t("sync.offline"),
                            icon: GetApp,
                            disabled: !assignmentsIds.length || !isOnline || canLockedAssignments || !canSyncDownAssignments,
                            onClick: assignmentsSyncDownHandler

                        }
                    ] : []),
                    ...(canReleaseAssignments ? [
                        {
                            title: t("sync.release"),
                            icon: LockOpen,
                            disabled: !canReleaseAssignments || !isOnline,
                            onClick: openReleaseLockConfirmationModal

                        }
                    ] : []),
                    ...(canSyncUpAssignments ? [
                        {
                            title: t("sync.up"),
                            icon: Backup,
                            disabled: !assignmentsIds.length || !isOnline || !canSyncUpAssignments || canLockedAssignments,
                            onClick: assignmentsSyncUpHandler
                        }
                    ] : []),
                    {
                        title: t("sync.logs"),
                        icon: History,
                        disabled: false,
                        onClick: () => setOpenSyncInfoModal(true),
                    },
                ]
                : [],
        };
    }, [assignmentsIds?.length, t, isInternalCompleteAssignmentLoading, formattedRowsSelected.data, canAnswerIsSelected, isNotAnyInternalCompleted, canLockedAssignments, canResetAssignmentsStatus, resetAssignmentLoading, isCompleteAssignmentLoading, isOnline, canSendToWBAction, organizationLoading, canSyncUpAssignments, canSyncDownAssignments, assignmentsSyncDownHandler, canReleaseAssignments, assignmentsSyncUpHandler, handleInternalCompleteAssignment, handleResetAssignmentStatus, handleCompleteAssignment]);

    const onPaginationModelChange = useCallback((newPaginationModel) => {
        setPaginationModel(newPaginationModel)
        setLocalStorageItem(
            LOCAL_STORAGE_GRID_KEYS.ASSIGNMENTS_PAGINATION[keyPrefix],
            newPaginationModel
        );
    }, [keyPrefix])

    const handleCheckboxChange = useCallback((itemId) => {
        setRowSelectionModel((prevCheckedItems) => {
            const prevIds = Array.from(prevCheckedItems?.ids);
            let newIds = [];
            if (prevIds.includes(itemId)) {
                newIds = prevIds.filter((id) => id !== itemId);
            } else {
                newIds = [...prevIds, itemId];
            }
            return { ...prevCheckedItems, ids: new Set(newIds) };
        });
    }, []);

    const onFilterModelChange = useCallback(
        (newFilterModel) => {
            setFilterModel(newFilterModel);
            setLocalStorageItem(
                LOCAL_STORAGE_GRID_KEYS.ASSIGNMENTS_COLUMN_FILTER[keyPrefix],
                newFilterModel
            );
        },
        [keyPrefix]
    );
    return (
         <Container  maxWidth={false} className={classes.mainContainer}>
                <Box display={'flex'} flexDirection={'column'} height={'100%'}>
                  <Box p={2} display={'flex'} flexDirection={'row'} alignItems={'center'} >
                    {canGoBack && (
                        <IconButton aria-label="GoBack" size='small' color="inherit" onClick={() => history.goBack()}>
                            <ArrowBack />
                        </IconButton>
                    )}
                    <Typography  variant='h6'>{t("wkb.assignments.label")}</Typography>
                  </Box>
                  <Box sx={{ flex: 1 , minHeight:0 }}>
                    <DataGridV2
                      MobileCustomRowComponent={(props) => {
                        return <AssignmentCustomRow
                          selectedCheckBoxes={Array.from(rowSelectionModel?.ids)}
                          handleCheckboxChange={handleCheckboxChange}
                          onRowClick={handleRowClick}
                          objectModalListHandler={objectModalListHandler}
                          followUpAssignmentsHandler={followUpAssignmentsHandler}
                          item={props?.row}
                          key={props.rowId}
                        />
                      }}
                      localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.ASSIGNMENTS_SEARCH_TEXT[keyPrefix]}
                      localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.ASSIGNMENTS_COLUMN_FILTER[keyPrefix]}
                      localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.ASSIGNMENTS_COLUMN_SORT[keyPrefix]}
                      localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.ASSIGNMENTS_COLUMN_ORDER[keyPrefix]}
                      localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.ASSIGNMENTS_COLUMN_WIDTH[keyPrefix]}
                      localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.ASSIGNMENTS_COLUMN_VISIBILITY[keyPrefix]}
                      localDataGridViewIdentifier={LOCAL_STORAGE_GRID_KEYS.ASSIGNMENTS_DATAGRID_VIEW[keyPrefix]}
                      apiRef={apiRef}
                      checkboxSelection
                      rows={rows}
                      columns={columns}
                      loading={loadingAssignments}
                      pagination
                      filterMode="client"
                       filterModel={filterModel}
                      onFilterModelChange={onFilterModelChange}
                      customRowHeight={isMobile ? 80 : 62}
                      {...(!!paginationModel && { paginationModel })}
                      onPaginationModelChange={onPaginationModelChange}
                      rowSelectionModel={rowSelectionModel}
                      onRowSelectionModelChange={(newRowSelectionModel) => {
                        setRowSelectionModel(newRowSelectionModel);
                      }}
                      toolbarProps={{
                        ...getToolbarProps,
                        selectedRows: rowSelectionModel,
                        getData: getAssignmentsForPrintAndDownload,
                        title: t('wkb.assignments.label'),
        
                      }}
                      onRowClick={(params) => {
                        const assignmentId = params?.row?.assignmentId;
                        const selectedRow = assignments && assignments.find((x) => x.assignmentId === assignmentId);
                        if (!!selectedRow) {
                          handleRowClick(selectedRow);
                        }
                      }}
        
                    />
                   {openSyncInfoModal && <SyncInfoModal title={t("wkb.assignments.label")} selectedAssignments={formattedRowsSelected.data} open={openSyncInfoModal}
                                   onClose={handleInfoSyncClose} />}
                               {openReleaseLockConfirmModal && <ReleaseLockConfirmModal
                                   moduleTitle={t(`module.${SurveyType.WKB}`)}
                                   open={openReleaseLockConfirmModal}
                                   onClose={(release) => release ? releaseLockHandler() : setOpenReleaseLockConfirmModal(false)}
                                   aria-labelledby="alert-dialog-title"
                                   aria-describedby="alert-dialog-description"
                               />}
                               <LinkAssignmentModal id={OpenLinkModalId} open={openLinkModal} anchorEl={linkAssignment.element}
                                   onClose={followUpAssignmentsHandlerClose} data={linkAssignment.data} type={linkAssignment.type} />
                               {isObjectModal &&
                                   <SelectSingleObjectModal open={isObjectModal}
                                       buildings={all}
                                       canProjectLevel
                                       selectedBuilding={mappedState.selectedBuildingId}
                                       onSave={handleSaveObjects}
                                       onClose={handleCloseObjects} />
                               }
                               {canChangeResponsiblePerson && <SelectResponsiblePerson
                                   anchorEl={canChangeResponsiblePerson}
                                   canCreateRepairRequest
                                   customOplosser
                                   projectId={selected && selected.projectId}
                                   loading={organizationLoading}
                                   setLoading={(val) =>
                                       flushSync(() => {
                                           setOrganizationLoading(val);
                                       })
                                   }
                                   onSubmit={(data) => handleChangeResponsiblePersonForAssignment(data)}
                                   onClose={(data) => {
                                       setCanChangeResponsiblePerson(null)
                                   }
                                   } />}
                  </Box>
                </Box>
              </Container>
    )
}

const useStyles = makeStyles(theme => ({
    '@global': {
        '.MuiButtonBase-root:focus': {
            outline: 0,
        },
    },
    colorSuccess: {
        color: theme.palette.success.main
    },
    wbStatusIcon: {
        marginLeft: 4
    },
    grow: {
        flexGrow: 1,
        display: 'flex'
    },
    bold: {
        fontWeight: "bold"
    },
    headerTitleContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    progressStyle: {
        fontWeight: 'bold',
        fontSize: '12px',
        position: 'absolute',
        left: '50%',
        transform: 'translate(-50%, 0)',
        color: '#fff'
    },
    warning: {
        fill: '#ffc107'
    },
    pending: {
        fill: '#dc3545'
    },
    progressWrapper: {
        position: 'relative',
        color: theme.palette.grey[800],
        [theme.breakpoints.only('xs')]: {
            width: '100%',
        },
        [theme.breakpoints.only('sm')]: {
            width: '100%',
        }
    },
    customMainHeader: {
        fontSize: 12,
        '& .MuiButtonBase-root': {
            [theme.breakpoints.only('xs')]: {
                fontSize: 14,
            },
            [theme.breakpoints.only('sm')]: {
                fontSize: 16,
            },
            fontSize: 14,
            padding: 0,
            margin: 0,
            whiteSpace: 'nowrap '
        },
    },
    customHeaderTitle: {
        display: 'flex',
        alignItems: 'center'
    },
    tableIcon: {
        fontSize: 20,
        boxShadow: 'none',

    },
    iconMainContainer: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'visible',
        columnGap: 2,
        [theme.breakpoints.down('md')]: {
            justifyContent: 'space-around'
        },
    },
    iconContainer: {
        [theme.breakpoints.only('sm')]: {
            minWidth: 20,
        },
        [theme.breakpoints.only('xs')]: {
            minWidth: 15,
        },
        '& svg': {
            fontSize: 16
        },
        minWidth: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    mainContainer: {
        height: '100%',
        width: '100%',
        overflow: 'auto',
        padding: theme.spacing(0),
        background: theme.palette.background.default
    },
    customCheckbox: {
        [theme.breakpoints.down('md')]: {
            '& .MuiSvgIcon-root': {
                height: 14
            }
        },
    },
    customCell: {
        position: 'relative',
        height: 37,
        minHeight: 37,
        maxHeight: 37,
    },
    iconGridContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    paperStatus: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    paperGridContainer: {
        rowGap: 5
    },
    titlePaperContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    papersWrap: {
        maxWidth: 'fit-content'
    },
    paperContainer: {
        display: 'flex',
        gap: 10,
        flexWrap: 'wrap',
        background: theme.palette.common.white,
        marginBottom: 10,
        boxShadow: ' rgba(0, 0, 0, 0.16) 0px 1px 4px',
        padding: 5,
        [theme.breakpoints.down('sm')]: {
            '& > $papers:nth-child(2n)': {
                borderLeft: `2px solid ${theme.palette.grey[300]}`,
                paddingLeft: 10
            }
        }
    },
    paperChip: {
        height: 'fit-content',
        padding: theme.spacing(0.3, 0),
        color: theme.palette.common.white
    },
    chipProgress: {
        background: theme.palette.grey[600],
        color: theme.palette.common.white
    },
    chipClose: {
        background: `${red[500]} !important`,
        color: theme.palette.common.white
    },
    chipApproved: {
        background: `${green[500]} !important`,
        color: theme.palette.common.white
    },
    chipReOpen: {
        background: theme.palette.primary.main,
        color: theme.palette.common.white
    },
    papers: {
        flexGrow: 1,
        padding: theme.spacing(1),
        backgroundColor: theme.palette.common.white,
        borderRadius: 0,
        boxShadow: 'none',
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0, 0.5),
        },
    },
    cardTitleBold: {
        fontWeight: 'bold'
    },
    cardTitle: {
        fontSize: 12,
        [theme.breakpoints.only('xs')]: {
            fontSize: 14,
            lineBreak: 'anywhere',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineClamp: 1,
            wordBreak: "break-all", /* number of lines to show */
            display: "-webkit-box",
            boxOrient: "vertical",
            color: theme.palette.grey[800],
        },
        [theme.breakpoints.only('sm')]: {
            fontSize: 16,
            lineBreak: 'anywhere',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineClamp: 1,
            wordBreak: "break-all", /* number of lines to show */
            display: "-webkit-box",
            boxOrient: "vertical",
            color: theme.palette.grey[800],
        },
        color: theme.palette.grey[500],
        whiteSpace: 'wrap'
    },
    iconButton: {
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0),
        },
        padding: theme.spacing(.45, 0.5),
    },
    CustomIconButton: {
        height: 17,
        '& span:nth-child(1)': {
            [theme.breakpoints.down('md')]: {
                display: 'block',
                width: '13px'
            },
        },
    },
    assignmentsCardButton: {
        height: '100%',
        position: 'relative',
        width: '100%',
        fontSize: 14,
        [theme.breakpoints.only('xs')]: {
            fontSize: 14,
            marginTop: 4,
        },
        [theme.breakpoints.only('sm')]: {
            fontSize: 16,
            marginTop: 4,
        },
    },
    groen: {
        color: theme.palette.success.main,
    },
    rood: {
        color: theme.palette.secondary.main,
    },
    oranje: {
        color: theme.palette.warning.main,
    },
    colorWarning: {
        color: theme.palette.error.main,
        fontSize: 16
    },
    content: {
        maxWidth: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        
    },
    spacer: {
        height: 0,
        overflow: "hidden"
    },
}));
